import { showSuccessNotify } from "../../utils/Notiffication";
import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/market/ozon'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });


export default class MarketOzonApi {

    static async loadCards({ data = { shop: undefined, offerIds: undefined, archive: undefined, onlyNew: undefined }, ...params }) {
        return await fetchService({ url: '/loadcards', method: 'POST', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }

    // static async loadCategories({ data = undefined, ...params }) {
    //     return await fetchService({ url: '/loadcategories', method: 'POST', data, ...params })
    // }

    static async loadWarehouseStocks({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/loadwarehousestocks', method: 'POST', data, ...params })
    }

    static async uploadStocksAndPrices({ data = { shop: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/uploadstocksandprices', method: 'POST', data, ...params })
    }

    static async excelStocksAndPricesTmp({ data = { shop: undefined }, ...params }) {
        return await fetchService({ url: '/exceltocksandpricestmp', method: 'POST', data, options: { download: true }, ...params })
    }

    static async getCardsBySearch({ data = { shop: undefined, search: undefined, tab: undefined, providerId: undefined, filters: undefined, limit: undefined, page: undefined, errorType: undefined }, ...params }) {
        return await fetchService({ url: '/getcards', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getCategories({ data = { search: undefined }, ...params }) {
        return await fetchService({ url: '/getcategories', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async changeCard({ data = { shop: undefined, offer_id: undefined, field: undefined, value: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/changecard', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async updateByExcel({ data = { shop: undefined, file: undefined }, ...params }) {
        return await fetchService({ url: '/updatebyexcel', method: 'POST', data, ...params })
    }




    static async updateStocksAndPrices({ data = { shop: undefined, filter: undefined, rules: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/updatestocksandprices', method: 'POST', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }

    static async updatePrices({ data = { shop: undefined, filter: undefined, rules: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/updateprices', method: 'POST', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }



    static async excelStocksFbsActive({ data = { shop: undefined, search: undefined, tab: undefined, filters: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/excelstocksfbsactive', method: 'POST', data, options: { download: true }, ...params })
    }


    static async changeMarginality({ data = { shop: undefined, offer_id: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changemarginality', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changePrice({ data = { shop: undefined, offer_id: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeprice', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changeStock({ data = { shop: undefined, offer_id: undefined, value: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/changestock', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`Изменения для ${data.offer_id} сохранены`); return r })
    }

    static async changeArchive({ data = { shop: undefined, offerIds: undefined, value: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/changearchive', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }

    static async changeStopBrand({ data = { shop: undefined, offerIds: undefined, value: undefined, skladName: undefined }, ...params }) {
        return await fetchService({ url: '/changestopbrand', method: 'PATCH', data, notify: { success: false }, ...params })
            .then(r => { showSuccessNotify(`${r.message}`); return r })
    }




    static async excelPrices({ data = { shop: undefined, search: undefined, filters: undefined, tab: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/excelprices', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelAnalitycs({ data = { shop: undefined, search: undefined, filters: undefined, tab: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/excelanalitycs', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelData({ data = { shop: undefined, search: undefined, filters: undefined, tab: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/exceldata', method: 'POST', data, options: { download: true }, ...params })
    }

}